function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.38584 8.63979L11.1026 10.6727C11.3244 10.8375 11.66 10.7047 11.704 10.4389L12.2993 7.08742C12.3252 6.95457 12.1854 6.85366 12.0526 6.9046L11.0327 7.30918C10.6911 6.65087 10.4694 5.85869 10.3745 5.06055H8.73342C8.74641 5.61194 8.80932 6.16337 8.92418 6.70781C9.01907 7.13837 9.13896 7.56291 9.31673 7.98749L8.43577 8.33612C8.30293 8.38606 8.27796 8.5569 8.38584 8.63979Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.48419 5.06055H2.10978L2.0209 6.80272H0.976124C0.843283 6.80272 0.754367 6.94856 0.824293 7.06246L2.49635 9.95741C2.6292 10.1912 2.9648 10.1912 3.09764 9.95741L4.76971 7.06246C4.8396 6.94856 4.75071 6.80272 4.61787 6.80272H3.5731L3.48419 5.06055Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5039 9.95741L18.1759 7.06246C18.2459 6.94856 18.157 6.80272 18.0241 6.80272H16.9793L16.8904 5.06055H15.516L15.4271 6.80272H14.3824C14.2495 6.80272 14.1606 6.94856 14.2305 7.06246L15.9026 9.95741C16.0354 10.1912 16.3711 10.1912 16.5039 9.95741Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 5.5924,
  height: 4.5542,
  rx: 0.317033,
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 6.70117,
  width: 5.59864,
  height: 4.5542,
  rx: 0.317033,
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 13.4082,
  width: 5.59232,
  height: 4.5542,
  rx: 0.317033,
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.60719 15.6246C6.61303 15.266 7.33716 14.315 7.33716 13.1862C7.33716 11.7507 6.17452 10.5879 4.73921 10.5879C3.30488 10.5879 2.14123 11.7507 2.14123 13.1862C2.14123 14.315 2.86639 15.266 3.87221 15.6246C2.01838 15.9123 0.620021 17.154 0.625996 19.3977C1.33019 19.7124 2.59471 20.0001 4.74022 20.0001C6.8867 20.0001 8.15122 19.7124 8.85541 19.3977C8.86139 17.153 7.46202 15.9123 5.60719 15.6246Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1277 15.6246C16.1335 15.266 16.8567 14.315 16.8567 13.1862C16.8567 11.7507 15.6941 10.5879 14.2587 10.5879C12.8244 10.5879 11.6608 11.7507 11.6608 13.1862C11.6608 14.315 12.3859 15.266 13.3917 15.6246C11.5379 15.9123 10.1395 17.154 10.1455 19.3977C10.8497 19.7124 12.1142 20.0001 14.2607 20.0001C16.4072 20.0001 17.6718 19.7124 18.3749 19.3977C18.3809 17.153 16.9826 15.9123 15.1277 15.6246Z",
  fill: "currentColor"
});

var SvgAssignment = function SvgAssignment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssignment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assignment.763501d0.svg";
export { ForwardRef as ReactComponent };